module.exports = __webpack_public_path__ + "img/tour.4bd78945.png";